import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { cn } from '../lib/cn'

interface BentoCardProps {
  title?: string
  description?: string
  action?: ReactNode
  children: ReactNode
  className?: string
  dark?: boolean
  delay?: number
  noPadding?: boolean
}

export function BentoCard({ title, description, action, children, className, dark, delay = 0, noPadding }: BentoCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24, scale: 0.97 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: '0px 0px -60px 0px' }}
      transition={{ type: 'spring', stiffness: 260, damping: 26, mass: 1, delay }}
      whileHover={{ scale: 1.008, transition: { type: 'spring', stiffness: 400, damping: 24, mass: 0.7 } }}
      className={cn(
        'rounded-card flex flex-col',
        dark ? 'glass-panel-dark text-white' : 'glass-panel text-canvas-fg',
        !noPadding && 'p-5 sm:p-6',
        className,
      )}
    >
      {(title || action) && (
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            {title && (
              <h3 className={cn('font-display text-base font-semibold', dark ? 'text-white' : 'text-canvas-fg')}>{title}</h3>
            )}
            {description && (
              <p className={cn('mt-0.5 text-sm font-medium', dark ? 'text-white/60' : 'text-canvas-fg/60')}>{description}</p>
            )}
          </div>
          {action}
        </div>
      )}
      {children}
    </motion.div>
  )
}
